export class Visualization {
    constructor(props) {
        this.props = props;
    }

    static restore(props) {
        return new Visualization(props);
    }

    setSerieVisible(classifier, visible) {
        if (!classifier) return false;

        const serieIndex = this.props.component.configs.series.findIndex(
            (serie) => serie.classifier === classifier
        );

        if (serieIndex < 0) return false;

        this.props.component.configs.series[serieIndex].visible = visible;

        return true;
    }

    setSeriesVisible(_classifiers, visible) {
        for (const classifier of _classifiers) {
            this.setSerieVisible(classifier, visible);
        }
    }
}
